<template>
  <v-dialog
    v-model="$store.state.downloadEmbeddedDocsModal.dialog"
    persistent
    max-width="1100"
  >
    <v-card tile>
      <v-card-title>
        Download documents
        <v-spacer></v-spacer>
        <v-btn
          text
          icon
          @click="$store.commit('CLOSE_EMBEDDEDDOCS_DOWNLOAD_MODAL')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text
        v-if="
          $store.state.downloadEmbeddedDocsModal.embeddedDocList &&
          $store.state.downloadEmbeddedDocsModal.embeddedDocList.length > 0
        "
      >
        <v-data-table
          class="mt-4 table--bordered elevation-1 table-header-style"
          dense
          :items-per-page="999"
          hide-default-footer
          :headers="[
            {
              text: 'Category',
              value: 'documentCategoryCode',
              sortable: true,
            },
            { text: 'Description', value: 'description', sortable: true },
            { text: 'Status', value: 'status', sortable: false },
            { text: 'Uploaded Date', value: 'dateCreated', sortable: true },
          ]"
          :items="$store.state.downloadEmbeddedDocsModal.embeddedDocList"
        >
          <template v-slot:[`item.documentCategoryCode`]="{ item }">
            {{ item.documentCategoryCode }}
          </template>
          <template v-slot:[`item.description`]="{ item }">
            <div
              class="secondary--text"
              @click="downloadEmbeddedDoc(item.fileDataId, item.embeddedDocId)"
              style="cursor: pointer"
            >
              <v-icon color="secondary" small> mdi-download </v-icon>
              <span>{{ item.description }}.{{ item.fileExtension }}</span>
            </div>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <div>
              {{
                $store.state.byteProEnumList.documentStatus.find(
                  (x) => x.key == item.status
                ).displayName
              }}
            </div>
          </template>
          <template v-slot:[`item.dateCreated`]="{ item }">
            <div v-if="!!item.dateCreated">
              {{ item.dateCreated | moment("MM/DD/YYYY HH:mm") }}
            </div>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="info"
          class="mx-3"
          elevation="0"
          @click="$store.commit('CLOSE_EMBEDDEDDOCS_DOWNLOAD_MODAL')"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DownloadEmbeddedDocsModal",
  methods: {
    async downloadEmbeddedDoc(fileDataId, embeddedDocId) {
      try {
        const resp = await this.$store
          .dispatch("embeddeddoc/getOne", {
            fileDataId: fileDataId,
            embeddedDocId: embeddedDocId,
          })
          .catch((err) => err);
        if (resp.status > 300) {
          throw resp.data;
        }
        const embeddeddoc = resp.data;
        this.downloadFile(
          embeddeddoc.description,
          embeddeddoc.fileExtension,
          embeddeddoc.documentData
        );
      } catch (err) {
        this.$store.commit("statusDialog/showErrorDialog", err);
      }
    },
    downloadFile(sourceName, sourceExtension, base64) {
      const element = document.createElement("a");
      const fileName = `${sourceName}.${sourceExtension}`;

      element.setAttribute(
        "href",
        `data:application/octet-stream;base64,${encodeURIComponent(base64)}`
      );
      element.setAttribute("download", fileName);
      element.click();
    },
  },
};
</script>

<style>
.theme--light.v-data-table.table-header-style
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  color: black;
}
</style>
